module.exports = __webpack_public_path__ + "img/fireworks.7c3fd02c.png";